import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { GenericAlternative } from "@/api/interfaces";
import { ReactComponent as PrescriptionBackgroundIcon } from "@/static/images/prescription-background.svg";

import styles from "./FindBestPriceGenericFlag.module.scss";

interface FlagProps {
  genericList: GenericAlternative;
  genericClickHandler: (name: string, option: string) => void;
  closeClickHandler?: () => void;
}

const GenericFlag = (props: FlagProps): JSX.Element => {
  const { genericList, genericClickHandler, closeClickHandler } = props;

  const clickHandler = (drug: GenericAlternative) => {
    const genericId = drug?.id.toString();
    genericClickHandler(drug.drug_name, genericId);
  };

  return (
    <span className={styles.GenericFlag} data-testid="generic-flag">
      <button
        className={styles.GenericFlagClose}
        type="button"
        aria-label="close"
        onClick={closeClickHandler}
        data-testid="find-best-price-generic-flag-close"
      >
        <Icon name="x" color="darkgreen" testId="find-best-price-generic-flag-close-icon" style={{ fill: "darkgreen" }} />
      </button>

      <Paragraph className={styles.GenericFlagCopy} testId="find-best-price-generic-flag-text">
        Try this generic to save even more money.
      </Paragraph>
      <span className={styles.GenericFlagGeneric}>
        <PrescriptionBackgroundIcon />
        <button
          type="button"
          className={styles.GenericFlagLink}
          onClick={() => clickHandler(genericList)}
          data-testid="find-best-price-generic-flag-link"
        >
          {genericList?.drug_name}
        </button>
      </span>
    </span>
  );
};

export default GenericFlag;
